import { StyleSheet, View } from 'react-native';

import { Text, tokens } from '@fhs/ui';

export function NewBadge() {
  return (
    <View style={styles.badge}>
      <Text.Ui weight="semibold" size="xs" style={styles.text}>
        NEW!
      </Text.Ui>
    </View>
  );
}

const styles = StyleSheet.create({
  badge: {
    backgroundColor: tokens.colors.$success,
    borderRadius: 4,
    paddingHorizontal: 8,
    paddingVertical: 3,
    alignSelf: 'center',
  },
  text: {
    color: tokens.colors.$white,
  },
});

